<script>
import UserBoProductListVue from 'App/users/components/tables/UserBoProductList.vue';

export default {
  name: 'UserCpProductList',
  extends: UserBoProductListVue,
  data: () => ({
    category: 'CHIP',
  }),
};
</script>
